/** Shared `DPopover` `:content` config for date/time & value pickers. `align` is set per caller. */
export const pickerPopoverContent = {
	side: 'bottom',
	onOpenAutoFocus: (event: Event) => event.preventDefault(),
} as const;

/**
 * Popover panel `:ui`: capped to the viewport with horizontal scroll so wide two-panel
 * bodies (range calendars, start/end editors) never overflow off-screen on narrow viewports.
 */
export const pickerPopoverUi = { content: 'max-w-[calc(100vw-2rem)] overflow-x-auto p-2' } as const;
